import React from 'react';
import { render } from 'react-dom';
import { RecoilRoot } from 'recoil';
import Application from './components/Application';
import './style.scss';
var CurrentApplication = Application;
function ApplicationWrapper() {
    return (React.createElement(RecoilRoot, null,
        React.createElement(CurrentApplication, null)));
}
var container = document.getElementById('app');
function renderApplication() {
    render(React.createElement(ApplicationWrapper, null), container);
}
renderApplication();
if (module.hot) {
    module.hot.accept('./components/Application', function () {
        CurrentApplication = require('./components/Application').default;
        renderApplication();
    });
}
